<template>
    <div>
        <template>
            <div class="" v-show="afterSuccess == false">
                <div id="errorMessageFile"></div>
                <div class="page-top mb-1 mb-3 align-center clearfix">
                    <h1 class="float-left"> Attendance Bulk Upload </h1>
                    <div class="progress-bar-holder">
                        <div class="progress step-one">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <ul class="prgress-number">
                            <li class="progress-number-list active">
                                <span class="bullet">
                                    1
                                </span>
                                <p> Upload </p>
                            </li>
                            <li class="progress-number-list active">
                                <span class="bullet">
                                    2
                                </span>
                                <p> Field Mapping </p>
                            </li>
                        </ul>
                    </div>
                    <button href="#" class="btn btn-primary float-right" id="process_dropzone_queue"> Proceed </button>
                    <router-link class="btn btn-primary float-right mr-1" to="/attendanceToday"> Cancel </router-link>
                </div>
                <div class="batch-upload-main">
                    <div class="batch-upload-inner">
                        <div class="upload-sheet" v-show="step_one == true">
                            <label for="" class="label block-label upload-label"> Upload a CSV <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title='".CSV" is a Microsoft Excel file format which is a requirement for Finja Business to read your file. Simple Excel file can be saved as a .CSV file using "save as" option listed under file menu on your Excel program.'></i>
                            </label>
                            <p> Download a sample template <a :href="`${$global.aws_base_url}/csv/BulkAttendance.csv`">here.</a></p>
                            <form  method="post" class="box dropzone drozone-label dz-clickable dropzone content mt-4" action="" id="drop" data-toggle="tooltip" data-placement="left" title="<p class='align-left'>Your CSV file must meet the following requirements in order to upload employees in Bulk: <br/>
                                1. Mandatory fields; Mobile (wallet) Number, Date.<br/>
                                2. Only add Registered Mobile (Wallet) Numbers.<br/>
                                3. Mobile numbers must be in the following format: 923XXXXXXXXX<br/>
                                4. Set the formatting of mobile number column to “Number” with zero decimal places.<br/>
                                5. No repetition of column names.<br/>
                                6. No empty cells in a valid row.<br/>
                                7. No special characters in the sheet.</p>">

                                <div class="box__input dz-message">
                                    <label class="drozone-label" for="file">
                                        <img  id="uploadIcon" for="file" src="/images/svgs/upload-icon.svg" alt="" class="upload">
                                        <span for="file" class="filename"> Drop your file here </span>
                                    </label>
                                    <label class="uploadedFileName">Drop your file here</label>
                                </div>
                            </form>
                            <em class="dropzone-or"> Or </em> <label id="selectFromComputer" for="file" class="btn btn-primary select-file-btn"> Select from your computer </label>
                        </div> <!-- upload sheet -->

                        <div class="mandatory-informations-main" v-show="step_two == true">
                            <div class="preview">
                                <label> Please check if we have correctly picked your data. </label>
                                <div class="table-holder" id="fieldmapping_table">
                                    <table id="addNewJoinerField">
                                        <tbody>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="afterSuccess == true">
                <div class="attandance-bulk-batch-summary">
                    <h2 class="bulk-upload-heading mb-3"> Batch Summary </h2>
                    <div class="row normal-ib-space mb-3">
                        <div class="col-md-4">
                            <div class="attandance-batch-summary-counter">
                                <strong class="number">{{notFound}}</strong>
                                <p>Total Unregister Wallets</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="attandance-batch-summary-counter">
                                <strong class="number">{{total}}</strong>
                                <p>Total Attendance Entries</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="attandance-batch-summary-counter">
                                <strong class="number">{{update}}</strong>
                                <p>Total Attendance Updated</p>
                            </div>
                        </div>
                    </div>
                    <div v-if="unRegistered.length > 0">
                        <div class="unregister-wallets-head mb-3">
                            <h3> Unregister Wallet id's </h3>
                            <p> Please check if we have correctly picked data </p>
                            <button class="btn btn-primary" @click="csvExport();"> Download All </button>
                        </div>
                        <div class="table-holder">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th width="20">Sr.</th>
                                        <th>Wallet ID</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(mob,index) in unRegistered">
                                        <td>{{index+1}}</td>
                                        <td >{{mob}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>

    export default {
        data() {
            return {
                afterSuccess: false,
                step_one : true,
                step_two : false,
                csvFile : this,

                fileAdded : false,
                dropZoneObject : null,
                filecolumn : [],
                fileRowData : [],
                unRegistered: {},
                notFound : 0,
                total: 0,
                update: 0,
            };
        },
        mounted() {
            this.initDropZone();
            $(".drozone-label").tooltip({
                html	: true,
                template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner large"></div></div>',
            });
            $("#drop").dropzone();

        },
        
        methods: {
            csvExport() {
                let that = this;
                let csvContent = "data:text/csv;charset=utf-8,";
                csvContent += [
                    ('Wallet ID'),
                    ...that.unRegistered.map(item => item)
                ]
                .join("\n")
                .replace(/(^\[)|(\]$)/gm, "");
                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", "Unregister Wallets.csv");
                link.click();
            },

            initDropZone(){
                let that = this;
                var fileName = '';
                Dropzone.options.drop = {
                    addRemoveLinks: true,
                    paramName: 'file',
                    maxFilesize: 2, // MB
                    uploadMultiple: false,
                    maxFiles: 1,
                    minFiles: 1,
                    queueLimit:1,
                    headers : window.axios.defaults.headers.common,
                    url: that.$global.base_url+'api/uploadBulkSheetAttendance',
                    acceptedFiles: '.csv',
                    autoProcessQueue:false,
                    init: function(){
                        $('#process_dropzone_queue').attr('disabled', 'disabled');
                        var _this = this;
                        that.dropZoneObject = this;
                        var selectedFile = document.getElementById('selectFromComputer');
                        selectedFile.addEventListener('click',function(){
                            _this.hiddenFileInput.click();
                        });
                        this.on("maxfilesexceeded", function(file) {
                            this.removeAllFiles();
                            this.addFile(file);
                        });
                        this.on('removedfile',function(file){
                            that.fileAdded = false;
                            $('div.box__input').show();
                        }),
                        this.on("addedfile", function(file) {
                            that.fileAdded = true;
                            that.checkFileForErrors(file);
                            
                            $('#process_dropzone_queue').removeAttr('disabled');
                        });
                        var nextButton_top = document.querySelector("#process_dropzone_queue");
                        function processFileLocal(){
                            if(that.isAPIAvailable()){
                                $.when(that.handleFileSelect(that.dropZoneObject.files[0])).done(function(p){});
                            }
                        }
                        function processQueueLocal(){
                            that.$Progress.start();
                            $('div.progress').addClass('step-three').removeClass('step-two');
                            that.dropZoneObject.processQueue(); // Tell Dropzone to process all queued files.
                        }
                        nextButton_top.addEventListener("click", function(e){
                            processQueueLocal();
                        });
                        that.dropZoneObject.on("sending", function(file, xhr, formData) {
                            that.$Progress.start();
                            $('div#preloader').removeClass('hidden');
                            // Will send the filesize along with the file as POST data.
                            formData.append("filesize", file.size);
                            formData.append("_token", $('#_token').val());
                            var mapIdentifier = [];
                            var selVal = '';
                            $( "select.selectpicker.mapping" ).each(function() {
                                selVal = $(this).find('option:selected').val();
                                mapIdentifier.push(selVal);
                                selVal = '';
                            });
                            formData.append("mapIdentifier", JSON.stringify(mapIdentifier));
                        });
                        that.dropZoneObject.on("totaluploadprogress", function(progress) {

                        });
                        that.dropZoneObject.on("uploadprogress", function(file, progress, bytesSent) {
                            // Update progress bar with the value in the variable "progress", which
                            // is the % total upload progress from 0 to 100
                            var progressBar = Math.floor(progress);
                            if(progressBar == 100){
                                that.$Progress.finish();
                                // that.$router.push('/attendanceToday');
                            }
                        });
                        that.dropZoneObject.on("success", function(file, obj) {

                            var msg = null;
                            if(obj.code == "200") {
                                that.total = obj.total;
                                that.update = obj.update;
                                that.notFound = obj.notFound;
                                that.unRegistered = obj.unRegisterd;
                                that.afterSuccess = true;
                                that.showToastBox('success', 'Attendance uploaded successfully');
                            }else if(obj.code == "2"){
                                msg = obj.message;
                            }else if(obj.code == "301"){
                                msg = obj.message;
                            }else{
                                msg = obj.message;
                            }
                            if(msg !== null){
                                that.showAlertBox('error','Error in file',msg);
                            }
                        });
                        that.dropZoneObject.on('error',function(file,errorMessage,xhr){
                            if(!file.accepted){
                                fileAdded = false;
                                var error_message = $('div#wrongfilemessage').html();
                                that.showAlertBox('error','Error in file',error_message);
                                this.removeFile(file);
                            }
                            if(401 == xhr.status){
                                swal.fire({
                                    title: "Session Expired",
                                    text: "Your session has expired. Would you like to be redirected to the login page?",
                                    type: "warning",
                                    showCancelButton: false,
                                    confirmButtonColor: "#DD6B55",
                                    confirmButtonText: "Yes",
                                    closeOnConfirm: false
                                }).then((result) => {
                                    if (result.value) {
                                        window.location = '/login';
                                    }
                                });
                            }else{
                                var msg = '<strong>Error:'+xhr.status+'</strong> '+xhr.statusText;
                                that.showAlertBox('error','Error in file', msg);
                            }
                            file.status = Dropzone.QUEUED;
                        });
                    }
                };
                $('.cross').on('click', function(e){
                    that.dropZoneObject.removeAllFiles();
                    $('label.uploadedFileName').html('Drop your file here');
                    $('#process_dropzone_queue').removeAttr('disabled');
                });
            },
            checkFileForErrors(file){
                var reader = new FileReader();
                reader.readAsText(file);
                var that = this;
                reader.onload = function(event){
                    var csv = event.target.result;
                    var data = $.csv.toArrays(csv);
                    var col = [];
                    var duplicate = false;
                    var column = false;
                    var duplicateArray = [];
                    for(var row in data) {
                        if(row == 0){
                            for(var item in data[row]) {
                                var value = data[row][item];
                                value = value.replace(/[^\w\s]/gi,'');
                                if(col.indexOf(value) > -1){
                                    duplicate = true;
                                    duplicateArray.push(value);
                                }
                                col.push(value);
                            }
                        }else{
                            break;
                        }
                    }
                    if(duplicate == true && that.fileAdded == true){
                        // $('div#duplicatemessage').html() +
                        var error_message =  duplicateArray.toString();
                        that.showAlertBox('error','Duplicate column name',error_message);
                        that.onFileError();

                    }else if(col.length < 3 && that.fileAdded == true){

                        column = true;
                        var error_message = $('div#columnfourmessage').html();
                        that.showAlertBox('error','Missing column',error_message);
                        that.onFileError();
                        
                    }else if(duplicate == true || column == true){
                        that.dropZoneObject.removeAllFiles();
                    }else{
                        that.handleGeneratePayrollButton();
                    }
                };
                reader.onerror = function(){ this.showAlertBox('Unable to read ' + file.fileName); }.bind(this);
            },

            onFileError(){
                let that = this;
                that.dropZoneObject.removeAllFiles();
                $('label.uploadedFileName').html('Drop your file here');
                $('#process_dropzone_queue').attr('disabled', 'disabled');
                return false;
            },

            handleGeneratePayrollButton(){
                var that = this;
                if(that.fileAdded == true){
                    if(this.isAPIAvailable()){
                        $.when(this.printTable(this.dropZoneObject.files[0]));
                    }
                }else{
                    $('a#payroll_proceed_top,a#payroll_proceed_bottom').attr('disabled','disabled').removeClass('active');
                }
            },
            handleFileSelect(file) {
                // read the file contents
                this.printTable(file);
                return true;
            },
            printTable(file) {
                let that = this;
                var url = $('#hidden-url').html();
                var reader = new FileReader();
                reader.readAsText(file);
                reader.onload = function(event){
                    var csv = event.target.result;
                    var data = $.csv.toArrays(csv);
                    for(var row in data){
                        if(row == 0){ // First Row fill in column
                            for(var item in data[row]){
                                var value = data[row][item];
                                that.filecolumn.push(value);
                            }
                        }else{
                            var _row = [];
                            for(var item in data[row]){
                                var value = data[row][item];
                                _row.push(value);
                            }
                            that.fileRowData.push(_row);
                        }
                    }
                    var html 		= '';
                    var test 		= '<table id="addNewJoinerField" class="table"><tr><td>Mobile Numbers</td><td>Start Date</td><td>End Date</td></tr>';
                    var colName		= '';
                    var selected 	= '';
                    var col = [];
                    for(var row in data) {
                        for(var item in data[row]) {
                            if(row == 0){
                                col[item] = [data[row][item]];
                            }else{
                                col[item].push(data[row][item]);
                            }
                        }
                    }
                    var startDate = col[1][0];
                    if(startDate == ''){
                        var startDate = col[2][0];
                    }
                    var endDate = col[col.length-1][0];
                    for(var item1 in col[0]) {
                        if(item1 == 0){
                        }else{
                            test += '<tr><td>'+col[0][item1]+'</td><td>'+startDate+'</td><td>'+endDate+'</td></tr>';
                        }
                    }
                    that.step_one = false;
                    that.step_two = true;
                    $('div.progress').addClass('step-two');
                    $('#fieldmapping_table').html(test);

                };
                reader.onerror = function(){ alert('Unable to read ' + file.fileName); };
            },
            isAPIAvailable() {
                // Check for the various File API support.
                if (window.File && window.FileReader && window.FileList && window.Blob) {
                    // Great success! All the File APIs are supported.
                    return true;

                } else {
                    // source: File API availability - http://caniuse.com/#feat=fileapi
                    // source: <output> availability - http://html5doctor.com/the-output-element/
                    document.writeln('The HTML5 APIs used in this form are only available in the following browsers:<br />');
                    // 6.0 File API & 13.0 <output>
                    document.writeln(' - Google Chrome: 13.0 or later<br />');
                    // 3.6 File API & 6.0 <output>
                    document.writeln(' - Mozilla Firefox: 6.0 or later<br />');
                    // 10.0 File API & 10.0 <output>
                    document.writeln(' - Internet Explorer: Not supported (partial support expected in 10.0)<br />');
                    // ? File API & 5.1 <output>
                    document.writeln(' - Safari: Not supported<br />');
                    // ? File API & 9.2 <output>
                    document.writeln(' - Opera: Not supported');
                    return false;
                }
            }

        }
    }
</script>
